var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-background"}),_c('Header'),(_vm.$route.path === '/')?_c('Home'):_vm._e(),_c('transition',{attrs:{"name":"page-zoom"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }